<template>
    <div>
        <section class="xlrclh">
            <img
                class="top-img"
                src="./../assets/imgs/61/title-bg.png"
                alt=""
            />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-1.png"
                        alt=""
                    />
                    <div class="content">
                        “彭州工匠”评选面向在彭州经济发展的各行各业中，具有工艺专长、掌握高超技能，技艺精湛、精益求精，严谨细致、专业敬业，长期坚守在生产服务一线岗位，并在本领域、行业内具有较高公认度和示范引领作用的产业工人代表。
                    </div>
                </div>
                <div class="rhtj mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-2.png"
                        alt=""
                    />
                    <div class="content">
                        颁发荣誉证书，给予入选者每人1万元的一次性奖励。
                    </div>
                </div>
                <div class="zccl">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-3.png"
                        alt=""
                    />
                    <div class="content">
                        <div>
                            <span class="hollow-cricle"></span
                            >评选条件包括基本条件和技能条件，连续在彭州工作一年以上，在基本条件全部满足的情况下，技能条件具备一个即可申报“彭州工匠”。在对彭州市经济建设中做出重大贡献的技能人才，可适当放宽参评条件。
                        </div>
                        <div class="des">
                            <div class="title">一、基本条件</div>
                            拥护中国共产党领导，自觉遵守宪法和法律，热爱祖国，爱岗敬业，善于创新，甘于奉献，具备优良的职业道德和职业操守。
                        </div>
                        <div class="des">
                            <div class="title">二、技能条件</div>
                            （1）获得国家、省、成都市、彭州市级技能荣誉称号；<br />
                            （2）世界技能大赛获奖选手；全国技能比赛前30名；省级技能比赛前10名；成都市级技能比赛前8名；彭州市技能比赛前3名；<br />
                            （3）彭州市及以上技能人才工作室领军人物；<br />
                            （4）在技术创新、攻克技术难关等方面做出突出贡献，并总结出独特的操作工艺和操作方法，产生重大经济效益或社会效益；<br />
                            （5）具有一定的绝技绝活，在挖掘和传承制造工艺上做出重大贡献等。<br />
                        </div>
                    </div>
                </div>
                <div class="gmlc">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-4.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">推荐申报</div>
                                </div>
                                <div class="line-content">
                                    推荐方式有：个人申报、企业推荐、行业协会推荐、所在基层工会推荐。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">资格审核</div>
                                </div>
                                <div class="line-content">
                                    按照“谁推荐、谁初审”的原则，由推荐单位对照“彭州工匠”的评选条件进行初审，个人申报的由工作地所在基层工会进行初审；市总工会对收集的工匠资料汇总后，向市级相关部门进行资格复审。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">3</div>
                                    <div class="line-title">专家评审</div>
                                </div>
                                <div class="line-content">
                                    市总工会组建专家评审委员会，明确评审要求和评分细则后，由评审专家从工匠精神、精湛技艺、创新能力、领军作用、突出贡献等方面进行分类评审和实地查看，召开综合评审会议，确定《“彭州工匠”候选人员建议名单》。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">
                                        市产业工人队伍建设改革领导小组审议
                                    </div>
                                </div>
                                <div class="line-content">
                                    将《“彭州工匠”候选人员建议名单》提请市产业工人队伍建设改革工作领导小组审议。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line" style="height: 118%"></div>
                                <div class="line-top">
                                    <div class="line-num">5</div>
                                    <div class="line-title">社会公示</div>
                                </div>
                                <div class="line-content">
                                    通过网络媒体对“彭州工匠”候选人员名单进行社会公示，接受社会监督，公示期不少于5个工作日。公示期内，对公示人选有异议，经调查核实成立的，取消评选资格。
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">6</div>
                                    <div class="line-title">确定人选</div>
                                </div>
                                <div class="line-content">
                                    公示无异议后，报请市委人才工作领导小组审批，形成《“彭州工匠”人员名单》。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sbcl">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-5.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="dot">1</div>
                                《“彭州工匠”推荐审批表》。
                            </div>
                            <div class="item">
                                <div class="dot">2</div>
                                就业证明。劳动合同、近半年社保缴费记录。
                            </div>
                            <div class="item">
                                <div class="dot">3</div>
                                基础信息。身份证、职称或技术等级证明材料、毕业证书。
                            </div>
                            <div class="item">
                                <div class="dot">4</div>
                                荣誉专利证明。有代表性的专利、奖励、荣誉称号、成果和论著等证明材料。
                            </div>
                            <div class="item">
                                <div class="dot">5</div>
                                党风廉政或政治审查材料。由申请人所在单位纪委或纪检组出具，私营和个体的由所在镇（街道）或村（社区）出具。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img
                        class="top"
                        src="./../assets/imgs/61/title-6.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-83873073">028-83873073</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            彭州市总工会
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/61/code.png" />
                    <img class="text" src="../assets/imgs/61/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() {},

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.xlrclh {
    background-color: $base-back;
    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }
    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;
            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }
        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    // margin-top: 0.5rem;
                    position: relative;
                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }
                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;
                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }
        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }
            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }
                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;
                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }
                        .line-title {
                            position: absolute;
                            left: 0.55rem;
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }
                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;
                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }
                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .code {
                width: 1.94rem;
                height: 1.94rem;
            }
            .text {
                height: 1.65rem;
            }
        }
    }
}
</style>
